import React from "react";
import Icon from "../Icon/Icon";
import "./menu.scss";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ReactTooltip from "@huner2/react-tooltip";
import Tooltip from "../Tooltip/Tooltip";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

type MenuItem = {
  id: string;
  text: string;
  link?: string;
  icon?: JSX.Element;
  target?: boolean;
  ref?: React.RefObject<any>;
  subMenu?: Array<MenuItem>;
  isTabTrade?: Boolean;
  tip?: string;
  tipHtml?: boolean;
  newPage?: boolean;
  isAddNewPage?: boolean;
  element?: JSX.Element;
  legacy?: boolean;
};

function Menu(props: { closeSideMenu: () => void }): JSX.Element {
  const { closeSideMenu } = props;
  const moreMenuRef = useRef(null);
  const docsMenuRef = useRef(null);
  const tradeMenuRef = useRef(null);
  const navigate = useNavigate();
  let menus = useMemo(() => {
    let items: Array<MenuItem> = [
      {
        id: "trade",
        text: "Trade",
        ref: tradeMenuRef,
        isTabTrade: true,
        subMenu: [
          {
            id: "futures",
            text: "Futures",
            link: "https://deri.io/#/pro/trade/futures",
          },
          {
            id: "options",
            text: "Options",
            link: "https://deri.io/#/pro/trade/option",
          },
          {
            id: "powers",
            text: "Powers",
            link: `https://deri.io/#/pro/trade/power`,
          },
          {
            id: "gamma",
            text: "Gamma",
            link: `https://deri.io/#/pro/trade/gamma`,
          },
        ],
      },
      { id: "pools", text: "Pools", link: "https://deri.io/#/pool" },
      {
        id: "docs",
        text: "Docs",
        ref: docsMenuRef,
        subMenu: [
          {
            id: "white-paper",
            text: "Whitepaper",
            link: "https://docs.deri.io/whitepaper",
          },
          {
            id: "code-audit",
            text: "Code Audit",
            link: "https://docs.deri.io/code-audits",
          },
          {
            id: "team",
            text: "Team",
            link: `https://misc.deri.io/#/team`,
            target: true,
          },
          {
            id: "faq",
            text: "FAQ",
            link: "https://docs.deri.io/library/faqs",
          },
          { id: "guide", text: "Guide", link: "https://docs.deri.io/" },
          {
            id: "github",
            text: "Github",
            link: "https://github.com/deri-protocol",
          },
        ],
      },
      {
        id: "more",
        text: "More",
        ref: moreMenuRef,
        isAddNewPage: true,
        subMenu: [
          {
            id: "deri-tools",
            text: "Deri Tools",
            link: `https://deri.io/#/deri-tools`,
          },
          {
            id: "bridge",
            text: "Bridge",
            link: `https://misc.deri.io/#/bridge`,
            target: true,
          },
          {
            id: "Referrals",
            text: "Referrals",
            link: `https://deri.io/#/referrals`,
            target: true,
          },
          {
            id: "token",
            text: "Token",
            link: `https://misc.deri.io/#/token`,
            target: true,
          },
          {
            id: "stats",
            text: "Stats",
            link: "https://info.deri.io/#/info",
            target: true,
          },
          {
            id: "governance",
            text: "Governance",
            link: `https://misc.deri.io/#/governance`,
            target: true,
          },
          {
            id: "v3",
            text: "V3 (Legacy)",
            link: "https://v3.deri.io/#/index",
            target: true,
          },
          {
            id: "testnet",
            text: "Testnet",
            link: "https://testnet.deri.io",
            newPage: true,
          },
        ],
      },

    ];
    return items;
  }, []);

  const toIndex = useCallback(() => {
    closeSideMenu();
    navigate("/index");
  }, [closeSideMenu, navigate]);
  return (
    <div className="menu">
      <div className="back-icon">
        <div className="logo" onClick={toIndex}>
          <Icon token="logo" />
          <span className="name">DERI</span>
        </div>
        <Icon token="close-modal-icon" onClick={() => closeSideMenu()} />
      </div>
      {menus.map((menu) => {
        return (
          <span
            className={`menu-item ${menu.id}-item`}
            key={menu.id}
            onClick={() => !menu.subMenu && closeSideMenu()}
          >
            {menu.subMenu ? (
              <>
                <SubMenu menu={menu} closeSideMenu={closeSideMenu} />
                <MSubMenu menu={menu} closeSideMenu={closeSideMenu} />
              </>
            ) : (
              <a
                rel="noreferrer"
                href={menu.link}
                target={menu.target ? "_blank" : ""}
              >
                {menu.text}
                {menu.legacy ? (
                  <>
                    <span className="legacy">Legacy</span>
                  </>
                ) : null}
              </a>
            )}
          </span>
        );
      })}
      <a className="btn feed-back" href="https://forms.gle/TvwJ2kiscYqKfLxJ8">
        FEEDBACK{" "}
      </a>
    </div>
  );
}
function SubMenu({
  menu,
  closeSideMenu,
}: {
  menu: MenuItem;
  closeSideMenu: () => void;
}) {
  const [isTooltipOpen, setTooltipOpen] = useState(false);

  const hideTooltipHandler = useCallback(() => {
    setTooltipOpen(false);
  }, []);

  const onTooltipTriggerHover = () => {
    setTooltipOpen(true);
  };

  const onTooltipTriggerLeave = () => {
    hideTooltipHandler();
  };

  useEffect(() => {
    return () => {
      document.removeEventListener("mouseleave", hideTooltipHandler);
    };
  }, [hideTooltipHandler]);
  return (
    <div className="sub-item-box"
      onMouseLeave={onTooltipTriggerLeave}>
      <div
        className="sub-item"
        onMouseEnter={onTooltipTriggerHover}
        onMouseLeave={onTooltipTriggerLeave}
      >
        {isTooltipOpen ? <div className="open-sub-item"></div> : null}

        {menu.isAddNewPage ? <div className="have-new-page"></div> : null}
        {menu.text}
        <Icon
          token={isTooltipOpen ? "arrow-up" : "arrow-down"}
          width="20"
          height="20"
        />
      </div>
      {isTooltipOpen ? <div
        className="subMenu-item-box"
        onMouseEnter={onTooltipTriggerHover}
      >
        {menu.subMenu?.map((subMenu) => (
          <div className={`sub-menu-item ${subMenu.id}-item`} key={subMenu.id}>
            {" "}
            <a
              href={subMenu.link}
              onClick={closeSideMenu}
              target={menu.target ? "_blank" : ""}
              rel="noreferrer"
            >
              {subMenu.text}
            </a>
            {subMenu.newPage ? <div className="new-page">New</div> : null}
          </div>
        ))}
        {menu.icon}

      </div> : null}
    </div>
  );
}

function MSubMenu({
  menu,
  closeSideMenu,
}: {
  menu: MenuItem;
  closeSideMenu: () => void;
}) {
  const [isTooltipOpen, setTooltipOpen] = useState(false);
  const [tabTrade, setTabTrade] = useState("pro");
  const navigate = useNavigate();
  const tooltipWrapperRef = useRef(null);

  const hideTooltipHandler = useCallback(() => {
    const tooltipWrapperEl = tooltipWrapperRef.current;
    if (tooltipWrapperEl) {
      ReactTooltip.hide(tooltipWrapperEl);
      setTooltipOpen(false);
      document.removeEventListener("click", hideTooltipHandler);
    }
  }, []);

  const onTooltipTriggerClick = useCallback(() => {
    const tooltipWrapperEl = tooltipWrapperRef.current;
    if (tooltipWrapperEl) {
      if (isTooltipOpen) {
        ReactTooltip.hide(tooltipWrapperEl);
        setTooltipOpen(false);
      } else {
        ReactTooltip.show(tooltipWrapperEl);
        setTooltipOpen(true);
        setTimeout(() => {
          document.addEventListener("click", hideTooltipHandler);
        }, 0);
      }
    }
  }, [hideTooltipHandler, isTooltipOpen]);

  const tradeLink = useMemo(() => {
    if (tabTrade === "pro") {
      return [
        {
          id: "futures",
          text: "Futures",
          link: "https://deri.io/#/pro/trade/futures",
        },
        {
          id: "options",
          text: "Options",
          link: "https://deri.io/#/pro/trade/option",
        },
        {
          id: "powers",
          text: "Powers",
          link: `https://deri.io/#/pro/trade/power`,
        },
        // {
        //   id: "gamma",
        //   text: "Gamma",
        //   link: `https://deri.io/#/pro/trade/gamma`,
        // },
      ];
    } else if (tabTrade === "lite") {
      return [
        {
          id: "futures",
          text: "Futures",
          link: "https://deri.io/#/lite/trade/futures",
        },
        {
          id: "options",
          text: "Options",
          link: "https://deri.io/#/lite/trade/option",
        },
        {
          id: "powers",
          text: "Powers",
          link: `https://deri.io/#/lite/trade/power`,
        },
      ];
    }
  }, [tabTrade]);

  const swithcTab = useCallback(
    (e: { stopPropagation: () => void }) => {
      e.stopPropagation();
      if (tabTrade === "pro") {
        setTabTrade("lite");
      } else {
        setTabTrade("pro");
      }
    },
    [tabTrade]
  );

  return (
    <div
      className={classNames("m-sub-menu-box", {
        "open-m-sub-menu": isTooltipOpen,
      })}
      onClick={onTooltipTriggerClick}
      ref={tooltipWrapperRef}
    >
      <div className="menu-box">
        {isTooltipOpen ? (
          <Icon token="arrow-left" className="arrow-left" />
        ) : null}
        <div className="menu-box-show">
          {menu.text}
          {!isTooltipOpen ? <Icon token="arrow-right" /> : null}
        </div>
        {isTooltipOpen ? <div className="menu-box-hr"></div> : null}
      </div>
      <div
        className={
          isTooltipOpen
            ? "m-sub-menu-item m-show-sub-menu-item"
            : "m-sub-menu-item m-hide-sub-menu-item"
        }
      >
        {menu.isTabTrade ? (
          <div
            className={classNames("m-tab-pro-lite", {
              "pro-box-type": tabTrade === "pro",
              "lite-box-type": tabTrade === "lite",
            })}
            onClick={(e) => {
              swithcTab(e);
            }}
          >
            <div
              className={classNames("pro-lite-check", {
                "pro-type": tabTrade === "pro",
                "lite-type": tabTrade === "lite",
              })}
            >
              {"pro" ? "Pro" : "Lite"}
            </div>
          </div>
        ) : null}
        {menu.isTabTrade
          ? tradeLink &&
          tradeLink.map((subMenu) => (
            <div
              className={`sub-menu-item ${subMenu.id}-item`}
              key={subMenu.id}
            >
              {" "}
              <a href={subMenu.link} onClick={closeSideMenu} rel="noreferrer">
                {subMenu.text}
              </a>
            </div>
          ))
          : menu.subMenu?.map((subMenu) => (
            <div
              className={`sub-menu-item ${subMenu.id}-item`}
              key={subMenu.id}
            >
              {" "}
              <a href={subMenu.link} onClick={closeSideMenu} rel="noreferrer">
                {subMenu.text}
              </a>
              {subMenu.newPage ? <div className="new-page">New</div> : null}
            </div>
          ))}
      </div>
    </div>
  );
}

export default Menu;
